const $inject = ['$scope', '$timeout'];
const lbMapController = function ($scope, $timeout) {

  let vm = this;

  vm.map = null;
  vm.mapId = 'map' + $scope.$id;

  if (vm.gridSize == undefined) {
    vm.gridSize = 30;
  }

  $timeout(init);

  function init() {
    let mapPos = [0, 0];
    let zoomLevel = vm.zoomLevel || 14;

    if (vm.mapCenter) {
      mapPos = [vm.mapCenter.latitude, vm.mapCenter.longitude];
    }

    vm.map = L.map(vm.mapId, {
      zoom: zoomLevel,
      center: mapPos
    });

    L.gridLayer.googleMutant({
      type: 'roadmap',
    }).addTo(vm.map);

    $timeout(() => {
      const myIcon = L.divIcon({ className: 'map-icon' });
      const location = [vm.locations[0].Latitude, vm.locations[0].Longitude];
      const marker = L.marker(location, { icon: myIcon }).addTo(vm.map);
    });
  }

};

lbMapController.$inject = $inject;

export default lbMapController;



// WEBPACK FOOTER //
// ./src/components/lbMap/lbMapController.js